import { render } from "./CreatePostForm.vue?vue&type=template&id=7f69a1dc&scoped=true"
import script from "./CreatePostForm.vue?vue&type=script&lang=js"
export * from "./CreatePostForm.vue?vue&type=script&lang=js"

import "./CreatePostForm.vue?vue&type=style&index=0&id=7f69a1dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f69a1dc"]])

export default __exports__